var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full text-center py-6"},[_vm._v("© Hayok Medicare . 2025 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }